import Entity from '../../core/domain/entity';

export class IncomingMessage extends Entity<
  { [key: string]: any } | undefined
> {
  constructor(props: { [key: string]: any } | undefined) {
    super(props);
  }
}
